import { render, staticRenderFns } from "./CurriculumTopView.vue?vue&type=template&id=beb04d3a&scoped=true&lang=pug"
import script from "./CurriculumTopView.vue?vue&type=script&lang=js"
export * from "./CurriculumTopView.vue?vue&type=script&lang=js"
import style0 from "./CurriculumTopView.vue?vue&type=style&index=0&id=beb04d3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb04d3a",
  null
  
)

export default component.exports